export const apps = [
  {
    slug: 'drive-ready',
    name: 'DriveReady',
    tagline: 'Offline-first driving knowledge exam preparation with localized study plans, practice questions, and mock tests.',
    status: 'Coming soon',
    icon: '/assets/drive-ready-icon.png',
    accent: 'drive',
    // Keep the product page hidden while making its legal documents public.
    isPublic: false,
    isListed: true,
    legalMode: 'internal',
    highlights: ['Localized exam preparation', 'Study progress stored on device', 'No ads, analytics, accounts, or tracking'],
  },
  {
    slug: 'daily-horoscope',
    name: 'Daily Horoscope',
    tagline: 'Daily zodiac readings, lucky guidance, and an answer book for entertainment and self-reflection.',
    status: 'Coming soon',
    icon: '/assets/daily-horoscope-icon.png',
    accent: 'oracle',
    // Keep the product page hidden until its Google Play release is ready.
    isPublic: false,
    isListed: true,
    legalMode: 'internal',
    highlights: ['Daily zodiac readings', 'Local zodiac and language preferences', 'AdMob and Firebase disclosed'],
  },
  {
    slug: 'docreader',
    name: 'DocReader',
    tagline: 'A local Android document viewer and editor for PDFs, Office files, TXT files, and everyday file review.',
    status: 'Coming soon',
    icon: '/assets/docreader-icon.png',
    accent: 'doc',
    isPublic: false,
    legalMode: 'internal',
    highlights: ['Local document viewing and editing', 'All files access for document discovery', 'Ads, analytics, and diagnostics disclosed'],
  },
  {
    slug: 'teleprompter',
    name: 'Teleprompter – Script Reader',
    tagline: 'Create, manage, and automatically scroll scripts with flexible prompting controls.',
    status: 'Coming soon',
    icon: '/assets/teleprompter-icon.png',
    accent: 'oracle',
    isPublic: false,
    isListed: true,
    legalMode: 'internal',
    highlights: ['Scripts stored locally', 'Android display-over-other-apps option', 'AdMob and Firebase disclosed'],
  },
  {
    slug: 'device-cleaner',
    name: 'Device Cleaner',
    tagline: 'A simple Android utility for cleaning up device clutter and keeping everyday phone care easier.',
    status: 'Available on Google Play',
    playUrl: 'https://play.google.com/store/apps/details?id=com.wenhao.devicecleaner',
    privacyUrl: 'https://clean.2xhappiness.com/privacy/',
    termsUrl: 'https://clean.2xhappiness.com/terms/',
    icon: '/assets/device-cleaner-icon.webp',
    accent: 'fresh',
    isPublic: true,
    legalMode: 'external',
    highlights: ['Cleaner daily phone care', 'Built for Android users', 'Lightweight utility experience'],
  },
  {
    slug: 'speed-test',
    name: 'Speed Test',
    tagline: 'Measure download speed, upload speed, latency, and jitter, then keep a local history of your results.',
    status: 'Available on Google Play',
    playUrl: 'https://play.google.com/store/apps/details?id=com.doublehappiness.storypost',
    icon: '/assets/speed-test-icon.png',
    accent: 'speed',
    isPublic: true,
    legalMode: 'internal',
    highlights: ['Download and upload measurements', 'Latency and jitter testing', 'Test history stored locally'],
  },
  {
    // Keep this hidden legacy record so installed Story Post versions can
    // continue opening their original legal URLs.
    slug: 'storypost',
    name: 'Story Post',
    tagline: 'Turn your photos into ready-made story posts and beautiful social carousel images.',
    icon: '/assets/storypost-icon.png',
    accent: 'story',
    isPublic: false,
    isListed: false,
    legalMode: 'internal',
    highlights: ['Local photo processing', 'Ready-made story templates', 'No photo upload or AI training'],
  },
];

export const publicApps = apps.filter((app) => app.isPublic);

export function getAppBySlug(slug) {
  return apps.find((app) => app.slug === slug);
}
